const newseLatterData = [
	{
		id: '1',
		icon: { parentBg: '#beaaf7', childBg: 'rgb(131 88 255) ', svg: 'icon-wallet' },

		title: ['Start a Carbon Project'],
		text: "Are you an agricultural land holder who’s interested in a Carbon Farming project with CarbonPump? We’d love to hear from you!",
	},
	{
		id: '2',
		icon: { parentBg: '#c4f2e3', childBg: 'rgb(16 185 129)', svg: 'icon-wallet' },

		title: ['Making a Climate Pledge?'],
		text: 'Climate Action Digital Receipts are evidence of completed and verified climate action and may be used to substantiate sustainability claims. Click the Contact Us button below and we’ll help you get started.',
	},
	{
		id: '3',
		icon: { parentBg: '#cddffb', childBg: 'rgb(66 138 248)', svg: 'icon-gallery' },
		title: ['Do you have a product that increases soil carbon?'],
		text: 'CarbonPump has many farms looking to increase soil carbon in their soil. Get in touch with us today!',
	},
	{
		id: '4',
		icon: { parentBg: '#ffd0d0', childBg: 'rgb(239 68 68)', svg: 'icon-list' },
		title: ['Project Originator'],
		text: 'Are you a project originator who\'s interested in working with CarbonPump? We\'d love to hear from you!',
	},
];

export { newseLatterData };
